module.exports = __webpack_public_path__ + "static/media/profile.01b3cdfa.jpg";